import { Image } from '@unpic/react/nextjs';
import { stegaCleanValue } from '@/utils/sanity/stegaCleanValue';

interface ResponsiveImageProps {
	src?: string;
	alt?: string;
	priority?: boolean;
	width?: number;
}

const ResponsiveImage = ({ src, alt, width, priority = false }: ResponsiveImageProps) => (
	<>
		{src && (
			<Image
				src={src ?? ''}
				alt={stegaCleanValue(alt)!}
				width={width}
				priority={priority}
				fetchPriority={priority ? 'high' : 'auto'}
				loading="eager"
				className="block size-full rounded-3xl object-cover"
			/>
		)}
	</>
);

// to add custom query param for url
export const addQueryParamToUrl = (url: string, qParam: string) => {
	const isOtherParamExists = url.includes('?');
	return `${url}${isOtherParamExists ? '&' : '?'}${qParam}`;
};

export default ResponsiveImage;
